import {toast} from "react-toastify";
import Rodal from "rodal";
import React, {useEffect, useState} from "react";
import ChatTransferNotify from "./ChatTransferNotify";
import PopupSpinner from "../PopupSpinner";
import ChatTransferModalOld from "./ChatTransferModalOld";
import styles from "./ChatTransferModal.module.css";
import axios from "axios";
import {checkEmptyInputText, getEnvVariable} from "../../../utils/helpers";
import api from "../../../services/api"
import {Buffer} from 'buffer';
import Button from 'react-bootstrap/Button'
import {sendErrorLog} from "../../../utils/logger";
import {useEndpointsQueues} from "../../../hooks/useEndpointsQueues";
import {getAgentEndpoints} from "../../../services/Amazon/Connect";

const TRANSFER_STATE_SPINNER = 0;
const TRANSFER_STATE_CONTENT = 1;
const TRANSFER_STATE_NO_AVAILABLE_AGENTS = 2;
const TRANSFER_STATE_NO_QUICK_CONNECTS = 3;
const TRANSFER_STATE_ERROR = 4;

const ChatTransferModal = (props) => {

    const {
        newVersion,
        agentChatConfiguration,
        agentConfiguration,
        showPopup, setShowPopup,
        currentCustomerName,
        changeQueue,
        contacts,
        currentContact, // can be replaced by => contact.getContactId()
        queueName,
        config
    } = props;

    const [transferContentState, setTransferContentState] = useState(TRANSFER_STATE_SPINNER);
    const [queueKey, setQueueKey] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [endpoints, setEndpoints] = useEndpointsQueues(agentChatConfiguration)

    const {instanceId, chatTransfer} = agentChatConfiguration;
    const enableAgentNote = (chatTransfer?.enableAgentNote === true);

    useEffect(() => {
        if (showPopup) {
            initTransfer();
        }
    }, [showPopup]);

    const initTransfer = () => {
        updateAgentEndpoints();
    };

    const updateAgentEndpoints = () => {
        setTransferContentState(TRANSFER_STATE_SPINNER);

        getAgentEndpoints().then(endpoints => {
            if (Array.isArray(endpoints) && !endpoints.length) {
                setTransferContentState(TRANSFER_STATE_NO_QUICK_CONNECTS);
                return;
            }
            const queueId = contacts[currentContact]?.connection?.getQueue().queueARN.split(':')[5].split('/')[3];
            api.getQuickConnectsMetrics(config, {
                instanceId: instanceId,
                queueId: queueId,
                practiceId: agentChatConfiguration?.xApiClientId,
            })
                .then((response) => {
                    let endpointsPersist = false;
                    endpoints.forEach((endpoint, index) => {
                        const quickConnectId = endpoint?.endpointARN.split(':')[5].split('/')[3];
                        const queueMetrics = response?.data?.quickConnects[quickConnectId]?.queueMetrics;
                        endpoints[index].showEndpoint = false;
                        endpoints[index].queueName = response?.data?.quickConnects[quickConnectId]?.name;
                        if (queueMetrics) {
                            if ((queueMetrics?.agents?.online || 0) > 0) {
                                endpoints[index].showEndpoint = true;
                                endpointsPersist = true;
                            }
                        }
                    });
                    setEndpoints(endpoints);
                    if (endpointsPersist) {
                        setTransferContentState(TRANSFER_STATE_CONTENT);
                    } else {
                        setTransferContentState(TRANSFER_STATE_NO_AVAILABLE_AGENTS);
                    }
                })
                .catch((e) => {
                    setTransferContentState(TRANSFER_STATE_ERROR);
                    console.log(e)
                    sendErrorLog('Show transfer endpoints failed', {message: e.message});
                });
        }).catch((e) => {
            sendErrorLog('Can\'t get available transfer endpoints', {message: e.message});
        });
    }

    if (!newVersion) {
        return <ChatTransferModalOld {...props} />;
    }

    const getAgentsTransferNoteNum = (contact) => {
        return Object.keys(contact?.attributes)
            .filter(key => key.includes('transferredNote'))
            .length
    }

    const sendAgentTransferNote = async () => {
        if (checkEmptyInputText(noteText)) {
            setQueueKey(false);
            return;
        }
        try {
            const noteNum = getAgentsTransferNoteNum(contacts[currentContact])
            const note = JSON.stringify({
                agentName: agentConfiguration.name,
                agentUsername: agentConfiguration.username,
                value: noteText,
            });
            const noteEncoded = Buffer.from(note).toString('base64');
            let urlData = encodeURI(`instanceId=${instanceId}&contactId=${currentContact}&n=${noteNum}&note=${noteEncoded}`);
            await axios.patch(config.xApiUrl + '/agent/transfer/note?' + urlData, urlData, {
                headers: {
                    'x-api-key': config?.xApiKey,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
            let data  = {
                contactId:currentContact,
                queue:queueName,
                transferringMessage: noteText,
                agentUsername: agentConfiguration.name,
                transferringQueue: endpoints[queueKey]?.queueName ?? endpoints[queueKey]?.name ?? "",
            }
            api.sendTransferNote(config,data)
            setQueueKey(false);
            setNoteText('');
        } catch (e) {
            console.log(e);
        }
    }

    const onCancel = () => {
        setQueueKey(false);
        setNoteText('');
        setShowPopup(false);
    }

    return <Rodal visible={showPopup}
                  onClose={onCancel}
                  animation='slideDown'
                  width={520}
                  customStyles={{marginTop: '80px'}}
                  className={'chatTransfer'}
    >
        <div className={styles.chatTransferHeader} id="chat-transfer-header">Transfer Chat</div>
        <div className="modal-data">
            {
                transferContentState === TRANSFER_STATE_SPINNER ? <PopupSpinner style={{margin: '100px 0'}} /> : ''
            }
            {
                transferContentState === TRANSFER_STATE_CONTENT ?
                    <>
                        <p className={styles.transferConversationTitle} id="transfer-conversation-title">Transfer conversation with <b><u>{currentCustomerName}</u></b> to:</p>
                        <p className={styles.transferConversationQueueTitle}>Queue</p>
                        <div className="container">
                            <div className={"row row-cols-2 " + styles.queueNameTableRow}>
                                {
                                    endpoints && endpoints.length > 0 ?
                                        endpoints.map((item, key) => {
                                            return item.showEndpoint === true ?
                                                <div key={key} className="col" onClick={() => setQueueKey(key)}>
                                                    <label className={styles.queueName}>
                                                        <input type='radio'
                                                               checked={queueKey === key}
                                                               className={styles.radioButton}
                                                               readOnly
                                                        />
                                                        {item.queueName ?? item.name}
                                                    </label>
                                                </div> : ''
                                        }) : ''
                                }
                            </div>
                        </div>

                        {
                            enableAgentNote ? <>
                                    <p style={{marginTop: '32px'}}>
                                        <span className={styles.noteHeader}>Leave a note to next agent</span>
                                        <span className={styles.noteHeaderOptional}>(optional)</span>
                                    </p>
                                    <textarea
                                        id="contact-transfer-note"
                                        className={styles.noteText}
                                        placeholder={"Leave message here..."}
                                        maxLength={500}
                                        onChange={(e) => setNoteText(e?.target?.value || '')}
                                    />
                                    <div className={styles.noteCharCounter}>{noteText.length || 0}/500</div>
                                </>
                                :
                                <p style={{marginTop: '32px'}} />
                        }

                        <hr className={styles.chatTransferBottomLine}/>
                        <div style={{textAlign: 'right', padding: '24px 9px 9px 9px'}}>
                            <Button
                                className={styles.cancelButton + " category-cancel"}
                                variant="outline-primary"
                                onClick={onCancel}
                                id="contact-transfer-cancel-button"
                            >
                                Cancel
                            </Button>

                            <Button className={styles.transferButton}
                                    id="contact-transfer-button"
                                    disabled={queueKey === false}
                                    onClick={() => {
                                        sendAgentTransferNote();
                                        changeQueue(endpoints[queueKey]);
                                        setShowPopup(false);
                                        toast(<ChatTransferNotify/>);
                                    }}
                            >
                                Transfer
                            </Button>
                        </div>
                    </>
                    :
                    ''
            }
            {
                transferContentState === TRANSFER_STATE_NO_AVAILABLE_AGENTS ?
                    <>
                        <p className={styles.transferConversationTitle} id="transfer-conversation-title">No agents available.</p>
                        <div style={{textAlign: 'right', paddingTop: '25px'}}>
                            <Button className={styles.transferButton}
                                    id="contact-transfer-ok-button"
                                    onClick={() => {
                                        setShowPopup(false)
                                    }}
                            >
                                Ok
                            </Button>
                        </div>
                    </>
                    :
                    ''
            }
            {
                transferContentState === TRANSFER_STATE_NO_QUICK_CONNECTS ?
                    <>
                        <p className={styles.transferConversationTitle} id="transfer-conversation-title">There is no possibility to transfer to other queues.</p>
                        <div style={{textAlign: 'right', paddingTop: '25px'}}>
                            <Button className={styles.transferButton}
                                    id="contact-transfer-ok-button"
                                    onClick={() => {
                                        setShowPopup(false)
                                    }}
                            >
                                Ok
                            </Button>
                        </div>
                    </>
                    :
                    ''
            }
            {
                transferContentState === TRANSFER_STATE_ERROR ?
                    <>
                        <p className={styles.transferConversationTitle} id="transfer-conversation-title">Can't get available agents.</p>
                        <div style={{textAlign: 'right', paddingTop: '25px'}}>
                            <Button
                                className={styles.cancelButton + ' category-cancel'}
                                variant="outline-primary"
                                onClick={onCancel}
                                id="contact-transfer-cancel-button"
                            >
                                Cancel
                            </Button>

                            <Button
                                className={styles.transferButton}
                                onClick={() => {
                                    initTransfer()
                                }}
                                id="contact-transfer-retry-button"
                            >
                                Retry
                            </Button>

                        </div>
                    </>
                    :
                    ''
            }
        </div>
    </Rodal>
}

export default ChatTransferModal;
